<template>
  <!-- v-loading="mapLoading" -->
  <div class="map-container">
    <div id="allmap"></div>
    <!-- <gps-source @update="updateGpsSource" /> -->
    <div class="map-refresh">
      <a-radio-group  v-if="!isDemo" v-model="currentGps">
        <a-radio
            v-for="(item ,index) in equipmentCodes"
            :key="item"
            :value="item"
            @change="changeSource"
        >
          GPS设备{{ index+1 }}
        </a-radio>
      </a-radio-group>

      <a-button v-show="showByApp" @click="startStop">
        {{ startStopText }}
      </a-button>
      <a-button class="refresh" @click="refresh"> 刷 新 </a-button>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { pubLocGps, getPoi, shipAddressSequence, truckGeoRawDataList, getEstimatedDeliveryTime } from "./api.js";
import base from '@/api/base'
import { mapState } from 'vuex'
import {MAP_FIELDS} from '@/constants/ruleConfig'
import moment from 'moment';


// import gpsSource from "./components/gpsSource";

export default {
  name: "transOrderMap",
  components: {
    // gpsSource,
  },
  props: {
    // 司机电话号码
    driverPhone: {
      type: String | Number,
      default: "",
    },
    driverName: {
      type: String,
      default: "",
    },
    // gps来源 gps,app
    // gpsSource: {
    //   type: String,
    //   default: 'gps',
    // },
    startTime: {
      type: [String, Number],
      default: 0,
    },
    // 结束时间
    endTime: {
      type: [String, Number],
      default: 0,
    },
    licensePlate: {
      type: String,
      default: "",
    },
    transOrderOpitons: {
      type: Array,
      default: () => [],
    },
    isWaybill: {
      type: Boolean,
      default: false,
    },
    address: {
      default: () => [],
      type: Array,
    },
    siteStart: {
      type: Array,
      default: () => [],
    },
    siteEnd: {
      type: Array,
      default: () => [],
    },
    waybillStatus: {
      type: Number,
      default: 1,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isDemo: {
      type: Boolean,
      default: false,
    },
    isDemoAccount: {
      type: Boolean,
      default: false,
    },
    waybillCodes: {
      type: Array,
      default: () => []
    },
    waybillList:{
      type:Array,
      default:()=>[]
    },
    equipmentCodes:{
      type:Array,
      default:()=>[]
    },
    shippingOrderNo:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      startStopText: "轨迹回放",
      mapLoading: false,
      // sliderValue: 40,
      map: null,
      // 地图缩放等级
      zoomNum: 9,
      shouldShowInfo: false,
      infoWindow: null,
      setMarkerMap: [],
      siteHasCoordinateList: [],
      noData: false,
      showByApp: true,
      lineData: [],
      markerCar: null,
      circleFence: [],
      gpsSource: "gps",
      markerList: [],
      carList: [],
      isTemp:false,
      lastTime: '',
      signingTime:"",
      fictitious: false,
      currentGps:'',
    };
  },
  watch: {
    // '$props.orderId': function (curVal) {
    //   // this.queryOrderTransport()
    // },
    gpsSource: function (curVal) {
      this.queryOrderTransport();
    },
    siteEnd: function (curVal) {
      this.queryOrderTransport();
    },
    startTime: function (curVal) {
      this.queryOrderTransport();
    },
    isActive: function(curVal) {
      if (curVal && this.map) {
        this.map.setFitView([...this.setMarkerMap]);
      } else if (!this.map) {
        this.queryOrderTransport();
      }
    },
    equipmentCodes:function (newVal) {
      if(newVal?.length) {
        this.currentGps = newVal[0]
      }
    },
    // shouldPlay: function (culVal, oldVal) {},
  },
  computed: {
    ...mapState('orderRules', ['sensitiveFields']),
    isShowField(){
      return (field)=>{
        const {vehicleTrackSensitiveFields=[]} = this.sensitiveFields?.SENSITIVE_FIELDS || {};
        return vehicleTrackSensitiveFields.includes(field)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {});
    if(this.equipmentCodes?.length) {
      this.currentGps = this.equipmentCodes[0]
    }
  },
  methods: {
    updateGpsSource(val) {
      this.gpsSource = val;
    },
    addCircle(item) {
      let circle = new AMap.CircleMarker({
        center: [item.long, item.lat], // 圆心位置
        radius: 20, // 半径m
        strokeColor: "#00af66", // 线颜色
        strokeOpacity: 0.7, // 线透明度
        strokeWeight: 1, // 线粗细度
        fillColor: "#00af66", // 填充颜色
        fillOpacity: 0.1, // 填充透明度
      });
      this.circleFence.push(circle);
      this.map.add(circle);
    },
    clearMapData() {
      if(this.map && this.carList.length > 0){
        this.map.remove(this.carList);
      }
      if(this.map && this.markerList.length > 0){
        this.map.remove(this.markerList);
      }
      this.navg = null;
      this.setMarkerMap = []
      this.startStopText = "轨迹回放";
      if (this.map !== null) {
        this.map.remove(this.setMarkerMap.concat(this.circleFence));
        this.pathSimplifierIns?.setData([{ name: "路线0", points: [] }]);
        this.map.clearInfoWindow();
      }
    },
    async openInfoWindowAmap(pointData) {
      var info = [];
      info.push(
        "<div class='aMapInfoWIndow'><p '>车牌号 : " +
          this.licensePlate +
          "</p>"
      );
      const driverName = this.isDemoAccount? this.driverName.slice(0, 1) + '师傅':this.driverName
      info.push("<p >司机 : " + driverName + "</p>");

      if (this.noData) {
        // info.push(
        //   "<p >经纬度: " +
        //     pointData["lon"] +
        //     "," +
        //     pointData["lat"] +
        //     "</p></div>"
        // );
      } else {
        // info.push(
        //   "<p >经纬度: " + pointData["lon"] + "," + pointData["lat"] + "</p>"
        // );
        const res = await getPoi({
          location: `${pointData.lon},${pointData.lat}`
        })
        const city = `${res[0]?.province || ''}${res[0]?.city || ''}`
        if(pointData["placeName"] || city){
          info.push("<p >当前位置: " + `${pointData["placeName"] || city}` + "</p>");
        }
        if(pointData["gpsTime"]){
          info.push("<p >定位时间: " + pointData["gpsTime"] + "</p>");
        }
        if (this.$props.gpsSource !== "app") {
          // let temperature = `${pointData['temperature1'] ? pointData['temperature1'] + '℃' : '' || '-'}, ${
          //   pointData['temperature2'] ? pointData['temperature2'] + '℃' : '' || '-'
          // }, ${pointData['temperature3'] ? pointData['temperature3'] + '℃' : '' || '-'}, ${
          //   pointData['temperature4'] ? pointData['temperature4'] + '℃' : '' || '-'
          // }`;

          // let temperature = [];
          // for (let i = 0, len = 4; i < len; i++) {
          //   if (pointData.temperatureInfo[i]) {
          //     temperature.push(pointData.temperatureInfo[i].value + '℃');
          //   } else {
          //     temperature.push('-');
          //   }
          // }

          // //let temperature = `${pointData.temperatureInfo[0] || '-'}，${pointData.temperatureInfo[1] || '-'}，${pointData.temperatureInfo[2] || '-'}，${pointData.temperatureInfo[3] || '-'}`
          // if (pointData.temperatureInfo.length > 0) {
          //   info.push('<p >温度 : ' + temperature.join(',') + '</p>');
          // }
          let temperature = []
          if(this.isDemo){
            temperature = ['0℃', '6℃']
          } else{
            temperature = [
              pointData["minTemperature"]
                ? `${pointData["minTemperature"]}℃`
                : "-",
              pointData["minTemperature"]
                ? `${pointData["maxTemperature"]}℃`
                : "-",
            ];
          }
          if(this.isTemp){
            info.push("<p >温度 : " + temperature.join(",") + "</p>");
          }
          const speed = pointData["speed"] ? pointData["speed"] : '40'
          // info.push("<p >速度 : " + speed + "km/h</p></div>");
        }
      }

      let infoWindowAmap = (this.infoWindowAmap = new AMap.InfoWindow({
        content: info.join(""), //使用默认信息窗体框样式，显示信息内容
      }));
      infoWindowAmap.open(this.map, [pointData.lon, pointData.lat]);
    },
    startStop() {
      //清除车辆icon
      this.map.remove(this.carList);

      const startStopType = {
        stop: "暂停播放",
        moving: "继续播放",
        pause: "暂停播放",
      };
      if(!this.lineData.length) {
        this.$message.warning('当前车辆暂无轨迹')
        return
      }
      if (!this.navg) {
        let arrPoint = [];
        this.lineData.map((item) => {
          arrPoint.push([item.lon, item.lat]);
        });
        let distance = Math.round(AMap.GeometryUtil.distanceOfLine(arrPoint));
        this.navg = this.pathSimplifierIns.createPathNavigator(0, {
          loop: true,
          speed: distance / 2,
          pathNavigatorStyle: {
            width: 16,
            height: 32,
            content: this.PathSimplifier.Render.Canvas.getImageContent(
              require("../../assets/img/map/orderSearchCar.png"),
              onload,
              onerror
            ),
            strokeStyle: null,
            fillStyle: null,
          },
        });
      }

      let getNaviStatus = this.navg.getNaviStatus();
      switch (getNaviStatus) {
        case "stop":
          this.navg.start();
          break;
        case "moving":
          this.navg.pause();
          this.openInfoWindowAmap(this.lineData[this.navg.getCursor()["idx"]]);

          break;
        case "pause":
          this.navg.resume();
          this.infoWindowAmap.close();

          break;
      }
      //更新按钮文案
      this.startStopText = startStopType[getNaviStatus];
    },
    refresh() {
      this.clearMapData();
      this.queryOrderTransport();
    },

    async setDrivingRoute() {
      //清洗高德坐标数据用于绘制轨迹
      function parseRouteToPath(route) {
        var path = [];
        for (var i = 0, l = route.steps.length; i < l; i++) {
          var step = route.steps[i];

          for (var j = 0, n = step.path.length; j < n; j++) {
            path.push(step.path[j]);
          }
        }
        return path;
      }
      let pointStart = [],
        pointEnd = [],
        waypoints = [],
        _this = this;

      this.siteHasCoordinateList.map((item, ind) => {
        if (ind === 0) {
          pointStart = [item.long, item.lat];
        } else if (ind === this.siteHasCoordinateList.length - 1) {
          pointEnd = [item.long, item.lat];
        } else {
          waypoints.push([item.long, item.lat]);
        }
      });
      this.driving.search(
        pointStart,
        pointEnd,
        {
          waypoints,
        },
        function (status, result) {
          if (status !== "complete") {
            _this.$message({ type: "info", message: "获取线路规划失败" });
          } else {
            let routeData = parseRouteToPath(result.routes[0]);
            //未完成的运单路线规划截取一半
            if (_this.waybillStatus !== 4) {
              routeData.splice(routeData.length / 2);
            }
            let track = [];
            routeData.map((item) => {
              track.push({ lon: item.lng, lat: item.lat });
            });

            _this.lineData = track;
            _this.setPathNavigator(track);
            //_this.setDrivingPolyline(routeData);
          }
        }
      );
    },
    async addressToCoordinate(address) {
      return await new Promise((resolve, reject) => {
        this.geocoder.getLocation(address, async (status, result) => {
          if (status === "complete" && result.geocodes.length) {
            resolve(result.geocodes[0].location);
          } else {
            resolve(null);
          }
        });
      });
    },

    addCarIcon(point) {
      let classMove = this.waybillStatus !== 4 ? "mapCar move" : "mapCar";
      let iconCar = `<div class="${classMove}">
        </div>`;
      let markerCar = (this.markerCar = new AMap.Marker({
        position: [point.lon, point.lat],
        content: iconCar,
        offset: new AMap.Pixel(-18, -22),
      }));
      this.carList.push(markerCar)
      this.map.add(this.markerCar);
      this.setMarkerMap.push(this.markerCar);
    },
    setMarker(item, index) {
      let _this = this;
      let markerIcon = new AMap.Icon({
        size: new AMap.Size(45, 49),
        image: item.type === "2" ?
          require('../../assets/img/map/fawarehouse_40x44.svg')
          : require('../../assets/img/map/fawarehouse.svg'),
        imageSize: new AMap.Size(45, 49),
        // anchor: 'center',
        // imageOffset:
        //   item.type === "2" ? new AMap.Pixel(0, 0) : new AMap.Pixel(-95, -3),
      });

      // 将 icon 传入 marker
      let marker = new AMap.Marker({
        position: [item.long, item.lat],
        icon: markerIcon,
        offset: new AMap.Pixel(-10, -29),
        // label: {
        //   offset: new AMap.Pixel(20, 20),//修改label相对于maker的位置
        //   content: `<div class="gps-address">
        //   <div class="point-mark ${item.type === '2' ? 'start-point' : ''}">
        //   ${item.type === '2' ? '起点' : `目的地${index}`}
        //   </div>
        //   <span>${item.status || ''}</span>
        //   <div class="gps-address-mark">${item.address}</div>
        //   </div>`
        //   }
      });

      // let infoWindowContent = `<div class="custom-infowindow">
      //   <div class="text" >车牌号：${this.licensePlate || "-"}<br>司机姓名：${
      //   this.driverName || "-"
      // }<br>地址：${item.address}</div>
      //   ${item.type !== '2' && this.lastTime ? `<div class="gps-address-mark">预计送达：${moment(this.lastTime).format('YYYY-MM-DD HH:mm')}</div>` : ''}
      //   </div>`;
      let infoWindowContent = `<div class="custom-infowindow">
        <div>
          <div class="lable">${item.type === '2' ? '发货' : '收货'}地址</div>
          <div class="value">${item.address}</div>
        </div>
        <div>
          <div class="lable">司机姓名</div>
          <div class="value" >
            ${this.driverName || "-"}
            <text style="margin-left: 4px">${this.licensePlate || "-"}</text>
          </div>
        </div>
        ${item.type !== '2' && this.signingTime ?
        `<div>
          <div class="lable">${item.status === '已签收' ? '签收时间' : '预计送达'}</div>
          <div  class="value">
            ${moment(this.signingTime).format(this.fictitious ? 'YYYY-MM-DD' :'YYYY-MM-DD HH:mm')}
            ${this.fictitious ? '24点前' : ''}
          </div>
        </div>` : ''}
        ${item.type !== '2' && this.lastTime &&!this.signingTime?
        `<div>
          <div class="lable">${item.status === '已签收' ? '签收时间' : '预计送达'}</div>
          <div  class="value">
            ${moment(this.lastTime).format(this.fictitious ? 'YYYY-MM-DD' :'YYYY-MM-DD HH:mm')}
            ${this.fictitious ? '24点前' : ''}
          </div>
        </div>` : ''}
        </div>`

        ;

      function markerClick() {
        let infoWindow = (_this.infoWindow = new AMap.InfoWindow({
          content: infoWindowContent,
          offset: new AMap.Pixel(22, -24),
        }));

        infoWindow.open(_this.map, [item.long, item.lat]);
      }
      if(item.type == '2') {
        marker.on("click", markerClick);
      }

      // marker.on("mouseover", ()=>{
      //   marker.setLabel({
      //     offset: new AMap.Pixel(20, 20),//修改label相对于maker的位置
      //     content: `<div class="gps-address">
      //     <div class="point-mark ${item.type === '2' ? 'start-point' : ''}">
      //     ${item.type === '2' ? '起点' : `目的地${item.index}`}
      //     </div>
      //     <span>${item.status || ''}</span>
      //     <div class="gps-address-mark">${item.address}</div>
      //     ${item.type !== '2' && this.lastTime ? `<div class="gps-address-mark">预计送达时间${moment(this.lastTime).format('YYYY-MM-DD HH:mm')}</div>` : ''}
      //     </div>`
      //     })
      // });
      marker.on("mouseout", ()=>{
        marker.setLabel({})
      })

      this.map.add(marker);
      this.setMarkerMap.push(marker);
      this.markerList.push(marker)
      // 起始地/目的地自定义窗口
      if(item.type !== '2') {
        const windowMarker = new AMap.Marker({
          position: new AMap.LngLat(item.long, item.lat),
          content: `<div class="infowindow-content">${infoWindowContent}</div>`,    // 自定义信息窗体内容
          offset: new AMap.Pixel(-91, 20),
        })
        this.map.add(windowMarker);
        this.setMarkerMap.push(windowMarker);
        this.markerList.push(windowMarker)
      }
    },
    async loadMapData() {
      let siteList = [],
        siteHasCoordinateList = [];
      if (this.map !== null) {
        this.clearMapData();
      }
      if (this.waybillCodes.length) {
        const res = await getEstimatedDeliveryTime({
          waybillCodes: this.waybillCodes
        })
        const tt=this.waybillList.find(t=>t.waybillCode===res[0].waybillCode)
        this.signingTime=tt?tt.signingTime:'';
        this.lastTime = res[0]?.estimatedDeliveryTime || ''
        this.fictitious = res[0]?.fictitious || false
      }
      // let data = [];
      let transOrderOpitons = [];
      // if (this.isWaybill) {
      //   transOrderOpitons = [{ address: this.address }];
      // } else {
      //   transOrderOpitons = this.transOrderOpitons;
      // }

      // if(this.siteStart === null){
      //   return;
      // }
      const siteStart = this.siteStart || []
      const startAddress = [];
      const siteEnd = this.siteEnd || [];
      const endAddress =  []
      siteStart.forEach(site => {
        startAddress.push({
          address: site.address,
          long: site.longitude,
          lat: site.latitude,
          type: site.type+'',
        })
      })
      siteEnd.forEach((site, index) => {
        endAddress.push({
          ...site,
          signingTime: site.signingTime,
          address: site.address,
          long: site.longitude,
          lat: site.latitude,
          type: site.type+'',
          status: site.status || '',
          index,
        })
      })
      const data = [
        ...startAddress,
        ...endAddress
      ];
      //站点排线
      // let { response } = await shipAddressSequence({ data });
      siteList = data;

      //清洗站点经纬度数据
      await Promise.all(
        siteList.map(async (item, index) => {
          if (!(item.long && item.lat)) {
            let point = await this.addressToCoordinate(item.fullAddress);

            if (point === null) {
              return;
            }
            item.lat = point.lat;
            item.long = point.lng;
          }

          siteHasCoordinateList.push(item);
          this.setMarker(item, index);
          // this.addCircle(item);
        })
      );
      this.siteHasCoordinateList = siteHasCoordinateList;
      if(this.isDemo){
        this.setDrivingRoute()
      } else {
        this.requestForLine();
      }
      this.map.setFitView([...this.setMarkerMap]);
    },

    async queryOrderTransport() {
      if (!this.map) {
        await this.mapInit();
      }
      //调用新逻辑
      this.loadMapData();
    },

    requestForLine() {
      if (!this.startTime) {
        // this.showError("车辆未配载");
        return;
      }
      // this.showByApp = true;
      if (this.$props.gpsSource === "app") {
        this.drawByApp();
      } else {
        this.drawByCar();
      }
    },
     async getTempPublicCustomer(){
      const { customerCode } = this.$store.state.user
      const res= await base.getDictionary({
        status: 1,
        type: 'temp_public_customer',
      })
      const tempPublic=res.map(item=>item.dictionaryCode)
      this.isTemp=tempPublic.includes(customerCode)
    },
    drawByCar() {
      this.mapLoading = true;
      this.isTemp = this.isShowField(MAP_FIELDS.temperature)
      // this.getTempPublicCustomer()
      // let postData = {
      //   shipCode: '',
      //   carId: this.licensePlate,
      //   endTime: this.$dateFormatter(this.$props.endTime || new Date()),
      //   startTime: this.$dateFormatter(
      //     (this.$props.startTime && new Date(this.startTime)) || new Date(moment().add(-1, 'day')),
      //   ),
      // };

      // trackPlayback(postData)
      //   .then((data) => {
      //     this.mapLoading = false;
      //     //test
      //     // this.lineData = [];
      //     this.lineData = data.data;
      //     if (this.lineData.length === 0) {
      //       this.noData = true;
      //       this.setDrivingRoute();
      //     } else {
      //       this.noData = false;
      //       this.setPathNavigator(data.data);
      //     }
      //   })
      //   .catch((e) => {
      //     this.mapLoading = false;
      //   });

      let postData = {
        // from: 0,
        // size: 5,
        // paging: false,
        // key: 'fbh0qcwl2vinojp15madezkt4ugx6yr9',
        filter: {
          licensePlate: this.licensePlate,
          phone: this.driverPhone || null,
          // gpsStartTime: this.startTime,
          // gpsEndTime: this.endTime,
          trackMust:1,
          startTime: this.startTime,
          endTime: this.endTime,
          shippingOrder: this.shippingOrderNo || undefined,
          deviceCode: this.currentGps || undefined
        },
        strategy: 'ONLY_LICENSE_PLATE'
      };
      pubLocGps({...postData})
        .then((data) => {
          this.mapLoading = false;
          this.lineData = data.records;
          if (this.lineData.length === 0) {
            this.noData = true;
            // this.showByApp = false
            // this.setDrivingRoute();//如没有获取到轨迹数据则不绘制轨迹
          } else {
            this.noData = false;
            data.records.map((item) => {
              item["lon"] = item.lonGd;
              item["lat"] = item.latGd;
              item["gpsTime"] = item.gpstime;
              item["placeName"] = item.address;
            });
            this.setPathNavigator(data.records);
          }
        })
        .catch((e) => {
          this.mapLoading = false;
          // this.showByApp = false
        });
    },
    drawByApp() {
      if (!this.$props.driverPhone) {
        this.showError();
        return;
      }
      // let postData = {
      //   shipCode: '',
      //   carId: this.$props.driverPhone,
      //   endTime: this.$dateFormatter(this.$props.endTime || new Date()),
      //   startTime: this.$dateFormatter(
      //     (this.$props.startTime && new Date(this.startTime)) || new Date(moment().add(-1, 'day'))
      //   )
      // };
      //test
      // postData.carId = '13551108888';
      // postData.startTime = '2020-08-11 00:00:00';
      // postData.endTime = '2020-08-12 12:00:00';
      this.mapLoading = true;

      let postData = {
        // from: 0,
        // size: 5,
        paging: false,
        key: "fbh0qcwl2vinojp15madezkt4ugx6yr9",
        filter: {
          // startTime: '2020-11-01',
          // endTime: '2020-11-07',
          // phone: '13014308592',
          phone: this.$props.driverPhone,
          startTime: this.startTime,
          endTime: this.endTime,
        },
      };

      truckGeoRawDataList(postData)
        .then((data) => {
          this.mapLoading = false;
          //test
          // this.lineData = [];
          this.lineData = data.records;
          if (this.lineData.length === 0) {
            // this.showByApp = false;
            this.noData = true;
            this.pathSimplifierIns.setData([{ name: "路线0", points: [] }]);
            this.$message({
              message: "未查询到App的轨迹数据",
              type: "info",
            });
          } else {
            this.noData = false;
            data.records.map((item) => {
              item["lon"] = item.lonGd;
              item["lat"] = item.latGd;
              item["gpsTime"] = item.gpstime;
              item["placeName"] = item.address;
            });
            this.setPathNavigator(data.records);
          }
        })
        .catch((e) => {
          this.mapLoading = false;
        });
    },
    setPathNavigator(track) {
      if (!this.noData) {
        track.map((item) => {
          item["lon"] = parseFloat(item.lon);
          item["lat"] = parseFloat(item.lat);
        });
      }
      let lineData = [{ name: "路线0", points: track }];
      this.pathSimplifierIns.setData(lineData);
      this.map.setFitView([...this.setMarkerMap]);
      //将车辆icon添加到轨迹末端
      this.addCarIcon(track[track.length - 1]);
    },

    showError(msg) {
      this.$message.info(msg || "未获取到当前车辆有效GPS信息");
    },
    // 清空地图信息
    clear() {
      //销毁巡航器
      this.navg && this.navg.destroy();
    },

    mapInit() {
      return new Promise((resolve, reject) => {
        let _this = this;
        let map = (this.map = new AMap.Map("allmap", {
          zoom: 4,
          features: ["bg", "road"],
          scrollWheel: false,
          mapStyle: 'amap://styles/5415d2af821d8107c2bafa18f73bcf5b',
        }));
        AMap.plugin(
          ["AMap.Geocoder", "AMap.Driving", "AMap.ToolBar"],
          function () {
            // 异步加载插件
            _this.driving = new AMap.Driving({
              // map: _this.map,
              hideMarkers: true,
            });
            _this.geocoder = new AMap.Geocoder({});
            // _this.getShowData();
            map.addControl(
              new AMap.ToolBar({
                // 简易缩放模式，默认为 false
                // liteStyle: true,
              })
            );
          }
        );

        AMapUI.load(
          ["ui/misc/PathSimplifier", "lib/$"],
          function (PathSimplifier, $) {
            if (!PathSimplifier.supportCanvas) {
              alert("当前环境不支持 Canvas！");
              return;
            }
            _this.PathSimplifier = PathSimplifier;
            let pathSimplifierIns = new PathSimplifier({
              zIndex: 100,
              autoSetFitView: false,
              map: map, //所属的地图实例
              getPath: function (pathData, pathIndex) {
                let lnglatList = [];
                pathData.points.map((item) => {
                  lnglatList.push([item.lon, item.lat]);
                });
                return lnglatList;
              },
              getHoverTitle: function (pathData, pathIndex, pointIndex) {},
              renderOptions: {
                renderAllPointsIfNumberBelow: 100, //绘制路线节点，如不需要可设置为-1
                pathLineStyle: {
                  strokeStyle: "#4fad3b",
                  lineWidth: 4,
                  dirArrowStyle: true,
                },
                pathLineSelectedStyle: {
                  strokeStyle: "#4fad3b",
                  lineWidth: 4,
                },
                pathLineHoverStyle: {
                  strokeStyle: "#4fad3b",
                  lineWidth: 4,
                },
                pathNavigatorStyle: {
                  fillStyle: "#4fad3b",
                },
              },
            });
            pathSimplifierIns.on("pointMouseover", (e, info) => {
              let { pathData, pointIndex } = info;
              let pointData = pathData.points[pointIndex];

              _this.openInfoWindowAmap(pointData);
            });
            pathSimplifierIns.on("pointMouseout", (e, info) => {});

            _this.pathSimplifierIns = pathSimplifierIns;
            resolve();
          }
        );
      });
    },
    // 地图切换数据来源
    changeSource(){
      this.refresh()
    }
    // setDrivingPolyline(pointList) {
    //   let polyline = (this.polyline = new AMap.Polyline({
    //     path: pointList,
    //     isOutline: true,
    //     outlineColor: '#4fad3b',
    //     strokeColor: '#4fad3b',
    //     strokeOpacity: 1,
    //     strokeWeight: 6,
    //     // 折线样式还支持 'dashed'
    //     strokeStyle: 'solid',
    //     // strokeStyle是dashed时有效
    //     strokeDasharray: [10, 5],
    //     lineJoin: 'round',
    //     lineCap: 'round',
    //     zIndex: 50,
    //     showDir: true,
    //   }));

    //   polyline.setMap(this.map);
    //   this.addCarMarker(pointList[pointList.length - 1]);
    // },
    // addCarMarker(point) {
    //   let classMove = this.waybillStatus !== 4 ? 'mapCar move' : 'mapCar';
    //   let iconCar = `<div class="${classMove}">
    //     </div>`;

    //   let markerCar = new AMap.Marker({
    //     position: point,
    //     content: iconCar,
    //     offset: new AMap.Pixel(-22, -12),
    //   });
    //   this.map.add(markerCar);
    //   this.setMarkerMap.push(markerCar);
    //   this.map.setFitView([this.polyline, ...this.setMarkerMap]);
    // },
  },
};
</script>

<style lang="less" scoped>
.map-container {
  width: 100%;
  height: 500px;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
}
#allmap {
  width: 100%;
  height: 100%;
  border: 1px solid #d6d6d6;
}
.map-option {
  padding: 0 8px;
  margin: 1px;
  background: #fff;
  position: absolute;
  bottom: 0;
  z-index: 10000000;
}
.map-refresh {
  margin: 1px;
  position: absolute;
  right: 5px;
  top: 5px;
  .refresh {
    margin-left: 10px;
  }
}
</style>
<style lang="less">
.infowindow-content {
  background: #fff;
  padding: 10px;
  border-radius: 4px;
}
.custom-infowindow {
  // background: #fff;
  // padding: 10px;
  // border-radius: 4px;
  font-size: 14px;
  color: #1C2026;
  width: 226px;
  > div {
    display: flex;
    line-height: 20px;
    padding: 5px 0;
    .lable {
      color: #7E8694;
      width: 70px;
    }
    .value {
      flex: 1;
    }
  }
}
.amap-marker-label{
  border: none;
  padding: 11px 16px;
  font-size: 12px;
  line-height: 22px;
  border-radius: 4px;
  width: 248px;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  .gps-address {
    .point-mark {
      color: #526D8F;
      padding: 0px 8px;
      line-height: 22px;
      border: 1px solid #526D8F;
      display: inline-block;
      border-radius: 2px;
    }
    .start-point {
      color: #06B880;
      border: 1px solid #06B880;
    }
    .gps-address-mark {
      color: #666666;
      margin-top: 6px;
      white-space: pre-wrap;
    }
  }
}
.aMapInfoWIndow {
  p {
    margin: 0;
    font-size: 12px;
  }
}
.amap-info-contentContainer:hover .amap-info-outer {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.1), 0px 8px 10px 1px rgba(0, 0, 0, 0.06), 0px 3px 14px 2px rgba(0, 0, 0, 0.05);
}
.amap-info-content {
  border-radius: 4px;
  box-shadow: none;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1)) drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.06)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.05));
}
.bottom-center .amap-info-sharp {
  display: none;
}
.amap-info-close {
  right: 5px !important;
}
.mapCar {
  width: 16px;
  height: 22px;
  background: url("../../assets/img/map/orderSearchCar.png");
  background-size: cover;
  &.move {
    animation: carAnimate 0.2s infinite;
  }

  //   -webkit-animation: carAnimate  1s infinite;
}
@keyframes carAnimate {
  from {
    margin-left: 0px;
    transform: rotate(0deg);
  }
  to {
    margin-left: 1px;
    transform: rotate(1deg);
  }
}
</style>


